module.exports = __webpack_public_path__ + "static/media/checkConfirm.595ab3c8.svg";